// Equirectangular projection valid for a few-km-radius chunk around an origin.
// For Phase 2 streaming across larger areas, switch to per-chunk ENU planes.

const EARTH_RADIUS_M = 6_378_137;

export interface LocalMeters {
  x: number;
  z: number;
}

export function latLngToLocalMeters(
  lat: number,
  lng: number,
  originLat: number,
  originLng: number,
): LocalMeters {
  const dLat = ((lat - originLat) * Math.PI) / 180;
  const dLng = ((lng - originLng) * Math.PI) / 180;
  const meanLat = ((lat + originLat) * 0.5 * Math.PI) / 180;

  const x = dLng * Math.cos(meanLat) * EARTH_RADIUS_M;
  // Babylon is right-handed Y-up by default; we use +Z = north, +X = east.
  const z = dLat * EARTH_RADIUS_M;
  return { x, z };
}

export function localMetersToLatLng(
  x: number,
  z: number,
  originLat: number,
  originLng: number,
): { lat: number; lng: number } {
  const meanLat = (originLat * Math.PI) / 180;
  const lat = originLat + ((z / EARTH_RADIUS_M) * 180) / Math.PI;
  const lng = originLng + ((x / (EARTH_RADIUS_M * Math.cos(meanLat))) * 180) / Math.PI;
  return { lat, lng };
}

export function metersPerDegreeLat(): number {
  return (EARTH_RADIUS_M * Math.PI) / 180;
}

export function metersPerDegreeLng(lat: number): number {
  return (EARTH_RADIUS_M * Math.cos((lat * Math.PI) / 180) * Math.PI) / 180;
}
